import { citations, reactions } from '@Constants';

const supportedAssistantContexts = new Set([citations, reactions]);

export const isAssistantContextSupported = (context) => supportedAssistantContexts.has(context);

// Breadcrumb creation stores the chain's effective eligibility on derived crumbs. Keep the root
// fallback for older/session-restored breadcrumbs that predate that normalization.
export const resolveAssistantEligibility = (activeBreadcrumb, rootBreadcrumb) =>
  isAssistantContextSupported(activeBreadcrumb?.context) &&
  (activeBreadcrumb?.assistantEligible ?? rootBreadcrumb?.assistantEligible) === true;
